import { lazy, useCallback, useEffect, useMemo } from 'react';
import { useAccount } from '../../hooks/useAccount';
import useLocales from '../../hooks/useLocales';
import { useModalError } from '../../hooks/useModalError';
import { useModalState } from '../../hooks/useModalState';
import { useRouteState } from '../../hooks/useRouteState';
import { useRouter } from '../../hooks/useRouter';
import { RoutePath, getPage } from '../../pages';

const Modal = lazy(() => import('../modal'));

const ConnectModal = () => {
  const { setOpen, open } = useModalState();
  const { route } = useRouteState();
  const { navigate } = useRouter();
  const locales = useLocales();
  const { hideError } = useModalError();

  const { isConnected } = useAccount();

  useEffect(() => {
    setOpen(false);
  }, [isConnected, setOpen]);

  useEffect(() => {
    hideError();
  }, [route, hideError]);

  const {
    element: PageElement,
    title,
    state,
  } = useMemo(() => {
    const page = getPage(route.path);
    return { ...page, state: route.state };
  }, [route]);

  const onClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  const onBack = useCallback(() => {
    navigate(RoutePath.Signup);
  }, [navigate]);

  const isCanBack = useMemo(() => route.path !== RoutePath.Signup && route.path !== RoutePath.WalletInfo, [route.path]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={typeof title === 'string' ? locales[title] : title}
      onBack={isCanBack ? onBack : undefined}
    >
      <PageElement {...state} />
    </Modal>
  );
};

export default ConnectModal;
